export const partnersObj = () => ({
    fr: [
        {
            name: "Philippe Ciais",
            title: "Co-founder and Research Director, Institut Pierre-Simon Laplace (IPSL)",
            img: "",
        },
        {
            name: "Jean-Pierre Wigneron",
            title: "Co-founder and Head, INRAE Remote Sensing Lab, Bordeaux",
            img: "",
        },
        { name: "Arthur Calvi", title: "Data Analyst" },
        { name: "Ibrahim Fayad", title: "Research Scientist" },
        { name: "Yu Feng", title: "Research Scientist" },
        { name: "Sami Jouaber", title: "Research Scientist" },
        { name: "Agnès Pellissier-Tanon", title: "Research Scientist" },
        { name: "François Ritter", title: "Research Scientist" },
        { name: "Martin Schwartz ", title: "Data Analyst" },
        { name: "Yidi Xu", title: "Research Scientist" },
    ],
    dn: [
        {
            name: "Martin Brandt",
            title: "Co-founder and Professor of Geography, University of Copenhagen",
            img: "",
        },
        {
            name: "Rasmus Fensholt",
            title: "Co-founder and Professor of Geography, University of Copenhagen",
            img: "",
        },
        { name: "Dimitri Gominski", title: "Research Scientist" },
        { name: "Sizhuo Li", title: "Research Scientist" },
        { name: "Siyu Liu", title: "Research Scientist" },
        { name: "Maurice Mugabowindekwe", title: "Research Scientist" },
        { name: "Florian Reiner", title: "Research Scientist" },
    ],
    br: [
        {
            name: "Luiz Aragão",
            title: "Senior Scientist Head of Earth Observation and Geoinformatics Division, National Institute for Space Research (INPE)",
            img: "",
        },
        { name: "Celso H.L. Silva Junior", title: "Research Scientist" },
        { name: "Liana Anderson", title: "Research Scientist" },
        { name: "Daniel Braga", title: "Research Scientist" },
    ],
});
